import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { Icon, Button } from 'shared/components';

import theme from './AvatarUploadFileSizeExceeded.scss';

const propTypes = {
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
  }).isRequired,
  onCancel: PropTypes.func.isRequired,
  fileType: PropTypes.string.isRequired,
  maxSizeMB: PropTypes.number.isRequired,
};


const titleMessage = { id: 'Media.Create.FileTooLargeDialog.Title', defaultMessage: '**  File size too large' };
const bodyMessage = {
  id: 'Media.Create.FileTooLargeDialog.Body',
  defaultMessage: '** Max allowed size for files of type { fileType } is { maxSizeMB } MB.',
};
const dismissMessage = { id: 'General.Close', defaultMessage: '** Close' };

const AvatarUploadFileSizeExceeded = ({ intl, onCancel, fileType, maxSizeMB }) => {
  return (
    <React.Fragment>
      <div className={ theme.root }>
        <div className={ theme.header }>
          <span className={ theme.message }>
            <FormattedMessage { ...titleMessage } />
          </span>
          <div onClick={ onCancel } className={ theme.closingIconContainer }>
            <Icon name="naked-x" />
          </div>
        </div>
        <div className={ theme.content }>
          <FormattedMessage { ...bodyMessage } values={{ fileType, maxSizeMB }} />
        </div>
        <div className={ theme.footer }>

          <Button
            label={ intl.formatMessage(dismissMessage) }
            buttonType="naked"
            labelColor="blackMedium"
            className={ theme.cancelButton }
            onClick={ onCancel }
          />
        </div>
      </div>
    </React.Fragment>
  );
};

AvatarUploadFileSizeExceeded.propTypes = propTypes;

export default AvatarUploadFileSizeExceeded;
